import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// Self-hosted Khmer webfont (Khmer subset only). Latin glyphs aren't in these
// files, so they fall through to system-ui; only Khmer text is served from a
// single bundled font — identical weight on iOS and Android. Weights 400/500/
// 600/700 must all be loaded because index.css sets `font-synthesis: none`.
import '@fontsource/noto-sans-khmer/khmer-400.css';
import '@fontsource/noto-sans-khmer/khmer-500.css';
import '@fontsource/noto-sans-khmer/khmer-600.css';
import '@fontsource/noto-sans-khmer/khmer-700.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
